import { toggleLeftPaneAriaLabel } from './HamburgerButton.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';

let styles = require('./LeftRail.scss');
const classNames = require('classnames/bind').bind(styles);

export interface HamburgerButtonProps extends React.HTMLAttributes<HTMLDivElement> {
    isPaneExpanded: boolean;
    toggleHamburgerButton: () => void;
}

export const HamburgerButton = observer(function HamburgerButton(props: HamburgerButtonProps) {
    const { isPaneExpanded, toggleHamburgerButton } = props;

    return (
        <div
            className={classNames(
                styles.hamburgerButtonWrapper,
                isFeatureEnabled('fwk-fluentCommandBar') && styles.fluent
            )}>
            <IconButton
                checked={isPaneExpanded}
                className={styles.hamburgerButton}
                iconProps={{ iconName: ControlIcons.GlobalNavButton }}
                onClick={toggleHamburgerButton}
                title={loc(toggleLeftPaneAriaLabel)}
                ariaLabel={loc(toggleLeftPaneAriaLabel)}
                aria-expanded={isPaneExpanded}
            />
        </div>
    );
});
